export default "__VITE_ASSET__C0nY3lSM__"